var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseListItem',[_c('div',{staticClass:"flex -mx-3 py-1"},[_c('div',{staticClass:"flex-1 px-3"},[(_vm.contact)?[_c('p',[_vm._v(_vm._s(_vm.fullName))]),_c('p',{staticClass:"text-sm font-medium text-gray-600 tracking-wide"},[_c('a',{attrs:{"href":`mailto:${_vm.contact.email}`}},[_vm._v(_vm._s(_vm.contact.email))]),_vm._v(" • "),(_vm.hasValidPhoneFormat)?_c('a',{attrs:{"href":`tel:+30${_vm.contact.phone}`}},[_vm._v(_vm._s(_vm.contact.phone)+" ")]):_c('span',[_vm._v(_vm._s(_vm.contact.phone))])])]:_c('span',{staticClass:"text-red-600"},[_vm._v("missing contact")])],2),_c('div',{staticClass:"w-24 px-3 text-right"},[_c('span',{class:{
          'inline-block': true,
          'bg-green-200': _vm.subscription.active,
          'bg-red-200': !_vm.subscription.active,
          'px-3': true,
          'py-1': true,
          'leading-snug': true,
          rounded: true,
          'text-xs': true,
          'text-green-600': _vm.subscription.active,
          'text-red-600': !_vm.subscription.active,
          capitalize: true,
          'font-medium': true,
          'select-none': true,
        }},[_vm._v(" "+_vm._s(_vm.subscription.active ? 'active' : 'inactive')+" ")])]),_c('div',{staticClass:"w-48 px-3 text-right text-sm"},[_vm._v(" "+_vm._s(_vm.subscription.createdAtDiffForHumans)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }